import { RESET_STATE } from "./actionsTypes";

export const resetState = () => (
  {
    type: RESET_STATE
  }
)